import { cn } from '../lib/utils';
import { useIsPhone } from '../hooks/useIsPhone';
import { PhoneTitle } from './PhoneHeader';

/**
 * The top of an app page: the page title, and nothing else - no eyebrow above
 * it and no description below it. Actions go in the toolbar row under it
 * (PageToolbar, docs/DESIGN.md).
 *
 * On a phone the title moves into the sticky bar, right-aligned (PhoneTitle).
 */
export function PageHeader({ title, className, children }) {
  const isPhone = useIsPhone();
  if (isPhone) {
    return (
      <>
        <PhoneTitle title={title} />
        {children && <header className={className}>{children}</header>}
      </>
    );
  }
  return (
    <header className={cn('flex flex-col gap-1', className)}>
      <h1 className="page-title title-row">{title}</h1>
      {children}
    </header>
  );
}
